module.exports = __webpack_public_path__ + "static/img/3-pd.70740e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home/3-pd.png
// module id = liLq
// module chunks = 0